import { Link } from 'react-router-dom';
import './blogRelated.css';

export default function BlogRelated({ blogData }) {
    return (
        <div className='blogsRelatedDiv'>
            <div>
                <h3>Related Posts</h3>
                <div className='relatedPosts'>
                    {blogData.slice(0, 10).map((blog, blogIndex) => {
                        return (
                            <Link
                                key={blogIndex}
                                to={`/blog/details/${blog._id}`}
                                target='_blank'
                                rel='noopener noreferrer'
                            >
                                {blog.name}
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
